import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pt-2" }
const _hoisted_2 = { class: "row pb-1" }
const _hoisted_3 = { class: "flex sm6" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "flex sm12" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Protocol Staking Level ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" with a balance of ")
const _hoisted_8 = { class: "pl-4" }
const _hoisted_9 = { class: "row pt-2" }
const _hoisted_10 = { class: "flex sm12" }
const _hoisted_11 = { class: "flex sm6" }

import { Protocol } from "@/models/Protocol";
import { userModule } from "@/store/user";
import ProtocolSubscriptionSummary from "@/components/ProtocolSubscriptionSummary.vue";
import { computed, ref } from "vue";
import ContractInput from "./contractInput.vue";
import { Chain, ContractInfo } from "@/models/Contract";
import { StakingLevel } from "@/notifi_types";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
  protocol: { type: Protocol, required: false },
},
  emits: ["protocolUpdate"],
  setup(__props, { emit }) {

const props = __props


// eslint-disable-next-line no-undef


const activeProtocol = ref(props.protocol || new Protocol());

const wallet = computed({
  get(): string {
    return activeProtocol.value.protocolStakingWallet;
  },
  set(newVal: string): void {
    activeProtocol.value.protocolStakingWallet = newVal;
    emit("protocolUpdate", activeProtocol.value);
  },
});

const walletChain = computed({
  get(): Chain {
    return activeProtocol.value.protocolStakingChain;
  },
  set(c: Chain): void {
    activeProtocol.value.protocolStakingChain = c;
  },
});

const protocolStakingLevel = ref<StakingLevel>();
const protocolStakingBalance = ref<number>(0);

const setStakingWallet = async (ci: ContractInfo): Promise<void> => {
  activeProtocol.value.protocolStakingWallet = ci.address;
  activeProtocol.value.protocolStakingChain = ci.chain;
  emit("protocolUpdate", activeProtocol.value);
  refresh();
};

const refresh = async (): Promise<void> => {
  protocolStakingLevel.value = await activeProtocol.value.stakingLevel();
  protocolStakingBalance.value = await activeProtocol.value.stakingBalance();
};
refresh();

return (_ctx: any,_cache: any) => {
  const _component_va_button = _resolveComponent("va-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("strong", null, _toDisplayString(protocolStakingLevel.value), 1),
            _hoisted_7,
            _createElementVNode("strong", null, _toDisplayString(protocolStakingBalance.value) + " Notifi", 1),
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_va_button, {
                size: "small",
                icon: "refresh",
                color: "secondary",
                onClick: refresh
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(ContractInput, {
                chain: _unref(walletChain),
                initialAddress: _unref(wallet),
                showToken: false,
                chainPrompt: true,
                onContractInfo: setStakingWallet,
                label: "Protocol Staking Wallet"
              }, null, 8, ["chain", "initialAddress"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(ProtocolSubscriptionSummary, { protocol: activeProtocol.value }, null, 8, ["protocol"])
      ])
    ])
  ]))
}
}

})